import * as React from "react";
import { App } from "./app"
import { ArticleGW } from "./ArticleGW"
import { BDKalkCore } from "./BDKalkCore"
import { SelectionItemGW } from "./SelectionItemGW"
import { PADebug } from "./PADebug"


interface ChoiseControlVm {
    core: BDKalkCore
    selectionItem: SelectionItemGW
}

interface ChoiseControlStates {
    hovering: boolean,
    minusPressed: boolean,
    plusPressed: boolean,
    crossPressed: boolean
}

const PSUI = 9998 // Price unit index

/*  ChoiseControlQreportGW is the amount controlling device shown on each quick report item's left side,
 *  with plus and minus buttons and a text field in the middle where a new amount can be typed in.
 *  These are made specific for either the article's view or the quick report view with some differences,
 *  mainly that items within the quick report also have a cross button for removing the item out of the list,
 *  unlike the ChoiseControlGW class for the articles view items.  */
export class ChoiseControlQreportGW extends React.Component<ChoiseControlVm, ChoiseControlStates> {

    constructor(props: ChoiseControlVm) {
        super(props)
    }

    // Sets the reference to this control within the article item on initiation
    componentWillMount() {
        this.props.selectionItem.ConnectChoise(this)
    }

    /* This is called by react soon after creation and before this component is rendered, and it may
     * result in focus being set to the input area  */
    componentDidMount() {
        if (this.state.inputActive == true) {
            this.m_textInput.focus()
        }
    }

    state = {
        hovering: false,
        minusPressed: false,
        plusPressed: false,
        crossPressed: false,
        inputActive: false
    }
    
    // Handler for the clicks on the minus button, which are passed on to a handler within BDKalkCore
    MinusClick() {
        this.props.selectionItem.SetLocation("minus")
        this.SelectThisUnit()
    }

    // Handler for the minus button being pressed (which will change its graphics)
    MinusDown() {
        this.setState({ minusPressed:true })
    }

    // Handler for the minus button being released (which will change its graphics)
    MinusUp() {
        this.setState({ minusPressed: false })
    }

    // Handler for the plus button being pressed (which will change its graphics)
    PlusDown() {
        this.setState({ plusPressed: true })
    }

    // Handler for the plus button being released (which will change its graphics)
    PlusUp() {
        this.setState({ plusPressed: false })
    }

    // Handler for the clicks on the plus button, which are passed on to a handler within BDKalkCore
    PlusClick() {
        this.props.selectionItem.SetLocation("plus")
        this.SelectThisUnit()
    }

    // Handler for the clicks on the close button, which are passed on to a handler within BDKalkCore
    CloseClick() {
        this.props.selectionItem.SetLocation("cross")
    }

    // Handler for the close button being released (which will change its graphics)
    CloseUp() {
        this.setState({ crossPressed: false })
    }

    // Handler for the close button being pressed (which will change its graphics)
    CloseDown() {
        this.setState({ crossPressed: true })
    }

    // Handler for when the central area gets clicked (will change the control into typing mode)
    CenterClick() {
        this.props.selectionItem.SetLocation("input")
        this.SelectThisUnit()
    }
    
    // Handler for when the mouse leaves the numeric control (may affect the graphics of the control)
    MouseOut() {
        if (this.props.selectionItem.GetInputActive() == false) {
            this.setState({ minusPressed: false, plusPressed: false })
        }
        else {
            this.m_textInput.click()
        }
    }

    // Gives a warning if a given input is not a valid number
    handleBadInput() {
        if (this.m_textInput.value.length > 0) {
            alert("Du m� skrive inn mengde som et tall, du kan kun bruke sifrer og maks et komma tegn.")
        }
    }
    
    // Checks if the input is a valid number and enters it if so, or calls handleBadInput()
    processInput() {
        if (this.m_textInput == null) {
            PADebug.Debug("ChoiseControlQReportGW.processInput - no text input!")
            return
        }

        var tested = this.props.core.GetApp().ParseToPositiveNumber(this.m_textInput.value)

        if (tested == null) {
            this.handleBadInput()
            return
        }

        /* The number has been concidered valid and will be entered as 
           a new amount for the article. This also means that the total sum
           display has to be up to date afterwards. The following actions
           however may cause the thread to be killed due to some update which
           replaces the owner of an ongoing process, so instead of updating
           the total sum display directly at the end here, this action is
           delayed to ensure it an active thread when the delay has passed. */
        setTimeout(this.props.core.RedrawTotalSum.bind(this.props.core), 40)
        
        // The selection item should update to show changes in the sum
        setTimeout(this.props.selectionItem.forceUpdate.bind(this.props.selectionItem), 45)

        // ...the same works for the update of ext info view, which might need a refresh due to 
        // how the total weight displayed there get affected by an amount change.
        setTimeout(this.props.core.UpdateExtInfoView.bind(this.props.core), 50)
        
        this.props.selectionItem.props.article.SetAmount(tested)
        this.props.core.ResetExtInfoViewInputTrackings()
    }
    
    // Handler for keydown events
    onKeyDown(key: string) {
        var previousValue = ""
        var dat = this.GetNewValue()
        if (dat) {
            previousValue = dat
        }

        if ((key == "0") || (key == "1") || (key == "2") || (key == "3") || (key == "4") || (key == "5") || (key == "6") || (key == "7") || (key == "8") || (key == "9")) {
            if (this.HasBegunTyping() == false) {
                this.SetNewValue(key)
            }
            else {
                if (previousValue == "0") {
                    this.SetNewValue(key)
                }
                else {
                    this.SetNewValue(previousValue + key)
                }
            }

            this.processInput()
            this.forceUpdate()
            return
        }

        if ((key == ".") || (key == ",")) {
            if (this.HasBegunTyping() == false) {
                this.SetNewValue(key)
            }
            else {
                for (var p = 0; p < previousValue.length; p++) {
                    if (previousValue.charAt(p) == ",") {
                        return
                    }
                }
                this.SetNewValue(previousValue + ",")
            }

            this.processInput()
            this.forceUpdate()
            return
        }

        if (key == "Backspace") {
            if (this.HasBegunTyping() == false) {
                this.SetNewValue("")
            }
            else {
                var newStr = this.GetNewValue()
                if (newStr) {
                    if (newStr.length > 0) {
                        const prevStr = newStr
                        newStr = ""

                        for (var s = 0; s < (prevStr.length - 1); s++) {
                            newStr += prevStr.charAt(s)
                        }
                    }

                    if (newStr.length > 0) {
                        this.SetNewValue(newStr)
                    }
                    else {
                        this.SetNewValue("0")
                    }
                }
                else {
                    this.SetNewValue("0")
                }
            }

            this.processInput()
            this.forceUpdate()
            return
        }

        if ((key == "ArrowLeft") || (key == "ArrowRight")) {
            return
        }

        if ((key == "ArrowUp") || (key == "ArrowDown")) {
            return
        }

        if ((key == "Enter") || (key == "Tab")) {
            this.processInput()
            return
        }

        if (key == "Control") {
            return
        }
        
        return
    }
    
    render() {
        var amount = "(no amount)"

        if (this.props.selectionItem.props.article.GetAmount() != undefined) {
            var amount = this.props.core.GetApp().GetRoundedNumericString(this.props.selectionItem.props.article.GetAmount())
        }

        if (this.props.selectionItem.props.article.GetAmountHidden() == true) {
            amount = amount + "*"
        }
        
        // Hovering or selecting the item that owns this numeric control will have effect on its graphics
        if ((this.state.hovering == true) || (this.props.selectionItem.isSelected() == true)) {
            // the item is either selected or hovered by the mouse
            if (this.props.selectionItem.GetInputActive()) {
                this.props.core.GetApp().ReFocus(300) // Calls a delayed focus to the input area

                // Grey amount is the value shown in ligth gray when input is active but nothing has been entered yet
                var greyAmount = amount
                if (this.HasBegunTyping() == true) {
                    greyAmount = ""
                }

                var def = ""
                var dat = this.GetNewValue()
                if (dat) {
                    def = dat
                }

                var inputItem = <div style={{ display: "flex", flexDirection: "row", position: "relative", left: "4px", top: "11px", height: "15px" }}>
                    <div style={{ position: "relative", top: "-3px" }}>{def}</div>
                    <input
                        type="text"
                        ref={(input) => { if (input != null) this.m_textInput = input }}
                        id="inputToBeFocusedOn"
                        onKeyDown={(par) => { this.onKeyDown(par.key) }}
                        value={""}
                        autoFocus={true}
                        style={{
                            position: 'relative',
                            width: '1px',
                            height: '20px',
                            top: '-6px',
                            left: '0px',
                            border: '0px'
                        }}>
                    </input>
                </div>

                return <div style={{ height: "29px", display: "flex", flexDirection: "row" }}>
                    {/*   Close button   */}
                    <div
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: (this.state.crossPressed) ? "0px -150px" : "0px -90px",
                            width: "16px",
                            height: "29px"
                        }}
                        onClick={this.CloseClick.bind(this)}
                        onMouseDown={this.CloseDown.bind(this)}
                        onMouseUp={this.CloseUp.bind(this)}>
                    </div>
                    {/*   Minus button   */}
                    <div
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: (this.state.minusPressed) ? "-16px -120px" : "-16px -90px",
                            width: "22px",
                            height: "29px"
                        }}
                        onClick={this.MinusClick.bind(this)}
                        onMouseDown={this.MinusDown.bind(this)}
                        onMouseUp={this.MinusUp.bind(this)}>
                    </div>

                    {/*   Numeric input   */}
                    <div style={{
                        position: 'relative',
                        width: '47px',
                        height: '26px',
                        backgroundImage: "url(images/ChoisePanelCollection.png)"}}>

                        {inputItem}

                        <div style={{
                            color: "#BBBBBB",
                            position: 'relative',
                            width: '45px',
                            height: '20px',
                            top: '-10px',
                            left: '4px',
                            border: '0px'
                        }}>{greyAmount}
                        </div>
                    </div>

                    {/*   Plus button   */}
                    <div
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: (this.state.plusPressed) ? "0px -261px" : "0px -231px",
                            width: "22px",
                            height: "29px"
                        }}
                        onClick={this.PlusClick.bind(this)}
                        onMouseDown={this.PlusDown.bind(this)}
                        onMouseUp={this.PlusUp.bind(this)}>
                    </div>
                </div>;
            }
            else {
                return <div style={{ height: "29px", display: "flex", flexDirection: "row" }}>
                    {/*   Close button   */}
                    <div
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: (this.state.crossPressed) ? "0px -150px" : "0px -90px",
                            width: "16px",
                            height: "29px"
                        }}
                        onClick={this.CloseClick.bind(this)}
                        onMouseDown={this.CloseDown.bind(this)}
                        onMouseUp={this.CloseUp.bind(this)}>
                    </div>
                    {/*   Minus button   */}
                    <div
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: (this.state.minusPressed) ? "-16px -120px" : "-16px -90px",
                            width: "22px",
                            height: "29px"
                        }}
                        onClick={this.MinusClick.bind(this)}
                        onMouseDown={this.MinusDown.bind(this)}
                        onMouseUp={this.MinusUp.bind(this)}>
                    </div>
                    {/*   Central text - amount   */}
                    <div
                        style={{
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: "0px 0px",
                            cursor: "pointer",
                            minWidth: "39px",
                            padding: "4px"
                        }}
                        onClick={this.CenterClick.bind(this)}>{amount}
                    </div>
                    {/*   Plus button   */}
                    <div
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: (this.state.plusPressed) ? "0px -261px" : "0px -231px",
                            width: "22px",
                            height: "29px"
                        }}
                        onClick={this.PlusClick.bind(this)}
                        onMouseDown={this.PlusDown.bind(this)}
                        onMouseUp={this.PlusUp.bind(this)}>
                    </div>
                </div>;
            }
        }
        else { // THe item is not selected or being hovered by the mouse
            return <div style={{ height: "29px", display: "flex", flexDirection: "row" }}>

                {/*   Close button   */}
                <div
                    style={{
                        cursor: "pointer",
                        backgroundImage: "url(images/ChoisePanelCollection.png)",
                        backgroundPosition: "0px -60px",
                        width: "16px",
                        height: "29px"
                    }}
                    onClick={this.CloseClick.bind(this)}>
                </div>

                {/*   Minus button   */}
                <div
                    style={{
                        cursor: "pointer",
                        backgroundImage: "url(images/ChoisePanelCollection.png)",
                        backgroundPosition: "-16px -60px",
                        width: "22px",
                        height: "29px"
                    }}
                    onClick={this.MinusClick.bind(this)}>
                </div>

                {/*   Central text - amount   */}
                <div
                    style={{
                        backgroundImage: "url(images/ChoisePanelCollection.png)",
                        backgroundPosition: "0px -30px",
                        cursor: "pointer",
                        minWidth: "39px",
                        padding: "4px"
                    }}
                    onClick={this.CenterClick.bind(this)}>{amount}
                </div>

                {/*   Plus button   */}
                <div
                    style={{
                        cursor: "pointer",
                        backgroundImage: "url(images/ChoisePanelCollection.png)",
                        backgroundPosition: "0px -201px",
                        width: "22px",
                        height: "29px"
                    }}
                    onClick={this.PlusClick.bind(this)}>
                </div>
            </div>;
        }
    }

    public HasBegunTyping() {

        const last = this.props.core.GetLastExtInfoInputValue()

        if (last != null) {
            if (last == "") {
                return false
            }

            if (this.props.core.GetLastExtInfoInputIndex() == PSUI) {
                if (this.props.core.GetLastExtInfoInputArticleID() == this.props.selectionItem.props.article.GetIdentifier()) {
                    return true
                }
            }
        }

        return false
    }

    SetNewValue(newValue: string) {

        const inp = this.m_textInput
        if (inp) {
            inp.value = newValue
        }

        if (newValue == "") {
            this.props.core.SetLastExtInfoInput(PSUI, "0", this.props.selectionItem.props.article.GetIdentifier())
            return
        }

        this.props.core.SetLastExtInfoInput(PSUI, newValue, this.props.selectionItem.props.article.GetIdentifier())
    }

    GetNewValue() {
        const last = this.props.core.GetLastExtInfoInputValue()

        if (last != null) {
            if (this.props.core.GetLastExtInfoInputIndex() == PSUI) {
                if (this.props.core.GetLastExtInfoInputArticleID() == this.props.selectionItem.props.article.GetIdentifier()) {
                    return last
                }
            }
        }

        return null
    }

    SelectThisUnit() {
        this.props.core.FinishOngoingInput()
        this.props.core.SetLastExtInfoInput(PSUI, null, this.props.selectionItem.props.article.GetIdentifier())
        this.ClearLastInput()
    }

    ClearLastInput() {
        this.props.core.ClearLastExtInfoInput()
    }

    private m_holder: SelectionItemGW
    private m_textInput: HTMLInputElement  // A handle to the input object
}



// WEBPACK FOOTER //
// ./client/view/ChoiseControlQreportGW.tsx